import React, { useState } from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { logoutUser } from '../utils/authService';
import { clearTestActivity } from '../utils/proctoringSession';
import { WEB_URL } from '../utils/constants';

// eslint-disable-next-line unused-imports/no-unused-vars
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href={WEB_URL}>
        Assesshub
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: "url(./../images/login-page.svg)",
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme?.palette?.mode === 'dark' ? theme?.palette?.grey?.[900] : theme?.palette?.grey?.[50] || '#fafafa',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme?.spacing?.(8, 4) || '64px 32px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme?.spacing?.(1) || '8px',
    backgroundColor: theme?.palette?.secondary?.main || '#dc004e',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme?.spacing?.(1) || '8px',
  },
  submit: {
    margin: theme?.spacing?.(3, 0, 2) || '24px 0 16px',
  },
}));

export default function SignInSide(props) {
  const _classes = useStyles();
  // eslint-disable-next-line unused-imports/no-unused-vars
  let [_email, setEmail] = useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  let [_password, setPassword] = useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  let [_errorMsg, setError] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const isSigninFlow = typeof window !== "undefined" && window.location.pathname.includes("/signin");
    const redirectUrl = process.env.REACT_APP_NAME == "v2-hdfc" ? '/v2/user/signin' : '/v2/user/login';

    (async () => {
      await logoutUser();
      sessionStorage.clear();
      // Signing out ends the session: resuming afterwards asks for a photo again.
      clearTestActivity();
      props.setUser(false);
      window.location.href = redirectUrl;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  return (
    <>

    </>
  );
}